import { useEffect, useState } from 'react';
import { Box, Button, TextField, Tooltip, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { HOURS_URL } from '../utils/constants';
import useSave from '../utils/useSave';
import ConfirmDialog from './ConfirmDialog';

/** A head sets (or changes, or removes) a person's planned hours on one task. Removing is refused while time is logged on it. */
export default function PlanForm({ task, plan, personId, onChanged }) {
  const [value, setValue] = useState(plan ? String(plan.plannedHours) : '');
  const [confirming, setConfirming] = useState(false);
  const [busy, run] = useSave(onChanged);

  useEffect(() => setValue(plan ? String(plan.plannedHours) : ''), [plan?.plannedHours]); // eslint-disable-line react-hooks/exhaustive-deps

  const save = (event) => {
    event.preventDefault();
    run({ method: 'put', url: HOURS_URL, data: { taskId: task.taskId, personId, plannedHours: Number(value) } });
  };

  return (
    <Box component="form" onSubmit={save} display="flex" flexWrap="wrap" alignItems="center" gap={1}>
      <Typography component="label" htmlFor={`plan-${task.taskId}`} sx={{ fontSize: 12, fontWeight: 700, color: WD.ink }}>
        Planned hours
      </Typography>
      <TextField
        id={`plan-${task.taskId}`}
        type="number"
        size="small"
        required
        value={value}
        onChange={(event) => setValue(event.target.value)}
        inputProps={{ min: 0.25, max: 999.99, step: 0.25 }}
        sx={{ width: 110 }}
      />
      <Button type="submit" size="small" variant="contained" disabled={busy || !value || Number(value) === plan?.plannedHours}>
        {plan ? 'Update' : 'Set hours'}
      </Button>
      {plan && (
        <>
          <Tooltip title={plan.logged > 0 ? 'Time is logged against these hours - change them instead' : 'Remove these hours'}>
            <span>
              <Button size="small" color="error" onClick={() => setConfirming(true)} disabled={busy || plan.logged > 0}>
                Remove
              </Button>
            </span>
          </Tooltip>
          <ConfirmDialog
            open={confirming}
            setOpen={setConfirming}
            title="Remove planned hours"
            note={`Remove the ${plan.plannedHours}h planned for "${task.title}"?`}
            confirmLabel="Remove"
            loading={busy}
            onConfirm={() => run({ method: 'delete', url: `${HOURS_URL}/${plan.hourId}` })}
          />
        </>
      )}
      {plan?.updatedBy?.name && <Typography sx={{ width: '100%', fontSize: 11, color: WD.inkFaint }}>Last set by {plan.updatedBy.name}</Typography>}
    </Box>
  );
}
